import React from "react";
import {Button, Card, Col, Dropdown, Form, Icon, Row, Select, Spin, Table, message} from "antd";
import {sanitizeFieldName} from "../../util/methods";
import './style.css';
import * as _ from 'lodash';

import * as moment from "moment";
import jsPDF from "jspdf";
// Emoji and characters Helvetica can't print (asset names, locations) -> util/pdfText.js
import {createPdfTextTracker, unprintableNote, unprintableToast} from "../../util/pdfText";

const MyButton = ({color, onClick, children}) => (
  <Button style={{
    backgroundColor: color,
    color: color === 'white' ? "black" : color === 'yellow' ? 'black' : 'white',
  }} onClick={onClick}>{children}</Button>
);

class Report extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      clientFilterType: '',
      locationFilterType: '',
      assetTypeFilterType: '',
      assetSubTypeFilterType: '',
      assetCodeFilterType: '',
      documentTypeFilterType: '',
      downloadActive: false,
      location: [],
      client: [],
      subType: [],
      assetType: [],
      assetCode: [],
      assetSubTypeActive: true,
      assetCodeActive: true,
      documentTypeActive: true,
      selectedDocumentTypes: [],
    };
  }

  componentDidMount() {
    const {match, fetch} = this.props;
    if (match.params && match.params.id) {
      fetch(match.params.id);
    }
    this.props.fetchAllFiltersData();
  }

  componentWillReceiveProps(nextProps, nextContext) {
    // console.log(nextProps.filters);
  }

  componentWillUnmount() {
    const {form} = this.props;
    form.resetFields();
    this.props.clearDocumentReportProps();

  }

  onLocationChange = (e) => {
    const {form} = this.props;
    form.setFieldsValue({assetCode: [], documentType: [], assetSubType: []});
    if (e.length === 1 && e[0] === 'INTRANSIT') {
      this.setState({location: e, client: null});
    } else {
      this.setState({location: e})
    }
  };

  onClientChange = (e) => {
    const {form} = this.props;
    form.setFieldsValue({assetCode: [], documentType: [], assetSubType: []});
    // if (e.length === 1) {
    //   if (e[0] === 'All') {
    //     this.setState({client: 'All'});
    //   } else {
    //     this.setState({client: e});
    //   }
    // } else {
    //   this.setState({client: e});
    // }
    this.setState({client: e});
  };

  handleAssetTypesChange = (e) => {
    const {form} = this.props;
    form.setFieldsValue({assetSubType: [], assetCode: [], documentType: []});
    if (e.length === 1) {
      if (e[0] === 'All') {
        this.props.getEquipmentSubTypeByAssetTypes('All');
        this.setState({assetType: e});
      } else {
        this.props.getEquipmentSubTypeByAssetTypes(e);
        this.setState({assetType: e});
      }
    } else {
      this.props.getEquipmentSubTypeByAssetTypes(e);
      this.setState({assetType: e});
    }
  };

  onSubTypeChange = (e) => {
    const {form} = this.props;
    form.setFieldsValue({assetCode: [], documentType: []});
    // if (e.length === 1) {
    //   if (e[0] === 'All') {
    //     this.props.fetchAssetCodes(this.state.location, this.state.client, ['All'], this.state.assetType);
    //     this.setState({subType: values});
    //   } else {
    //     this.props.fetchAssetCodes(this.state.location, this.state.client, e, this.state.assetType);
    //     this.setState({subType: e});
    //   }
    // } else {
    //   this.props.fetchAssetCodes(this.state.location, this.state.client, e, this.state.assetType);
    //   this.setState({subType: e});
    // }
    this.setState({subType: e});
  };

  fetchDocumentType = (e) => {
    // console.log(e);
    const {form} = this.props;
    form.setFieldsValue({documentType: []});
    if (e.length === 1 && e[0] === 'All') {
      // if(e[0] === 'All') {
      // } else {
      //   this.props.fetchAssetCodes(this.state.location, this.state.client, this.state.subType, this.state.assetType, e);
      // }
    } else {
      if (e.length > 3)
        this.props.fetchAssetCodes(this.state.location, this.state.client, this.state.subType, this.state.assetType, e);
    }
    this.setState({assetCode: e});
  };

  handleSubmit = (e) => {
    const {match} = this.props;
    e.preventDefault();
    e.stopPropagation();

    this.props.form.validateFields((err, values) => {
      if (err) {
        return console.log(err);
      }
      const data = {};
      const {form: {getFieldValue}, assetCodes, filters, authUser, documentFilters, equipmentSubTypes} = this.props;
      const {
        assetCodeFilterType,
        documentTypeFilterType
      } = this.state;
      const documentTypes = filters && filters.type && filters.type.data && filters.type.data.data || [];
      if (assetCodeFilterType === 'All') {
        data.location = this.state.location;
        data.client = this.state.client;
        data.assetSubType = this.state.subType;
        data.assetCode = ['All'];
        data.assetType = this.state.assetType;
        //data.assetCode = assetCodes && assetCodes.length && assetCodes.map(item => item._id);
        // console.log(data);
        if (data.location[0] === 'All') {
          data.location = authUser && authUser.locations.map(item => item._id);
        }
        if (data.client[0] === 'All') {
          data.client = authUser && authUser.clients.map(item => item._id);
        }
        if (data.assetSubType[0] === 'All') {
          data.assetSubType = equipmentSubTypes && equipmentSubTypes.map(item => item._id);
        }
        if (data.assetType[0] === 'All') {
          data.assetType = documentFilters && documentFilters.assetType.map(item => item._id);
        }
      } else {
        data.assetCode = values.assetCode;
      }

      if (documentTypeFilterType === 'All') {
        data.documentType = documentTypes && documentTypes.length && documentTypes.map(item => item._id);
      } else {
        data.documentType = values.documentType;
      }
      // console.log(data);
      this.props.fetchDocumentAssetReportData(data);
      this.setState({downloadActive: true, selectedDocumentTypes: data.documentType});
    });
  };

  handleSelect = (type, value) => {
    switch (type) {
      case 'client':
        this.setState({
          clientFilterType: value,
        });
        break;
      case 'location':
        this.setState({
          locationFilterType: value,
          clientFilterType: 'Off',
        });
        if (value === 'INTRANSIT') {
          this.props.form.setFieldsValue({
            'client': ['Off'],
          })
        }
        break;
      case 'assetType':
        this.setState({
          assetTypeFilterType: value
        });
        break;
      case 'assetSubType':
        this.setState({
          assetSubTypeFilterType: value
        });
        break;
      case 'assetCode':
        this.setState({
          assetCodeFilterType: value,
        });
        break;
      case 'documentType':
        this.setState({
          documentTypeFilterType: value,
        });
        break;
      default:

    }
  };

  dropdownData = (item, type, pushDocumentColumn, refurbish) => {
    let data = [];
    item && item.length && item.map(itm => {
      if (itm && itm.type && itm.type.name && itm.type.name === type) {
        data.push(itm);
      }
    });

    data.sort(function (a, b) {
      // Turn your strings into dates, and then subtract them
      // to get a value that is either negative, positive, or zero.
      return new Date(b.renewalDate) - new Date(a.renewalDate);
    });

    const columns = [
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        render: (item) => <div> {item || ''}</div>
      },
      {
        title: 'Created Date',
        dataIndex: 'createdAt',
        key: 'createdAt',
        render: (item) => <div>
          {item && moment(item).format('DD-MM-YYYY') || 'NA'}
        </div>
      },
      {
        title: 'Document Date',
        dataIndex: 'documentDate',
        key: 'documentDate',
        render: (item) => <div>
          {item && moment(item).format('DD-MM-YYYY') || 'NA'}
        </div>
      },
      {
        title: 'Renewal Date',
        dataIndex: 'renewalDate',
        key: 'renewalDate',
        render: (item) => <div>
          {item && moment(item).format('DD-MM-YYYY') || 'NA'}
        </div>
      },
      {
        title: 'Attachment',
        dataIndex: 'attachment',
        key: 'attachment',
        render: (data, record, index) => <div> {record && record.file ?
          <a style={{display: 'block'}} key={record.file.path} href={`${record.file.path}`} target='_blank'>
            {`Attachment${index + 1}`}</a> : 'No Attachments'} </div>
      },
    ];

    return <React.Fragment>
      <Table
        style={{width: '100%', backgroundColor: '#c0c9ff'}}
        columns={columns}
        dataSource={data}
        pagination={false}
      />
    </React.Fragment>
  };

  hideDownloadButton = () => {
    this.setState({downloadActive: false});
  };

  assetTypeSelected = () => {
    this.setState({downloadActive: false, assetSubTypeActive: false});
  }

  assetSubTypeSelected = () => {
    this.setState({downloadActive: false, assetCodeActive: false});
  }

  assetCodeSelected = () => {
    const {form} = this.props;
    const assetCode = form.getFieldValue('assetCode');
    let data = {};
    if (assetCode.length === 1 && assetCode[0] === 'All') {
      data.location = this.state.location;
      data.client = this.state.client;
      data.subType = this.state.subType;
      data.assetType = this.state.assetType;
      data.assets = assetCode;

      // this.props.fetchDocumentType(data);
    } else {
      data.assets = assetCode;

      // this.props.fetchDocumentType(data);
    }
    this.setState({downloadActive: false, documentTypeActive: false});
  }

  downloadPdf = (headers, data) => {
    // console.log(headers, data);
    const deepClonedData = _.cloneDeep(data);
    const marginLeft = 20;
    let dataArray = [];
    const doc = new jsPDF({
      orientation: "l", //set orientation
      unit: "pt", //set unit for document
      format: [4000, 10000],
    });

    for (let i = 0; i < headers.length; i++) {
      let item = headers[i];
      if (item.dataKey !== 'assetCode' && item.dataKey !== 'assetType' && item.dataKey !== 'subType' && item.dataKey !== 'altName' && item.dataKey !== 'locationName'
        && item.dataKey !== 'subLocation') {
        // datesArray.push(item.key);
        deepClonedData.forEach(record => {
          record[item.dataKey] = 'Not Attached';

          if (record.documents && record.documents.length) {
            let renewRecords = (record.documents || []).filter(d_item => d_item.type.name === item.dataKey);
            if (renewRecords && renewRecords.length) {
              record[item.dataKey] = 'Attached';
              renewRecords = renewRecords.filter(item => item.renewalDate);
              if (renewRecords && renewRecords.length) {
                renewRecords.sort((a, b) => new Date(b.renewalDate).getTime() - new Date(a.renewalDate).getTime());
                record[item.dataKey] = (renewRecords && renewRecords.length) ? moment(renewRecords[0].renewalDate).format('DD-MM-YYYY') : 'Attached';
              }
            }
          }
        })
      }
    }

    deepClonedData.map((doc, i) => {
      dataArray[i] = {};
      headers.map(h => {
        dataArray[i][h.dataKey] = doc[h.dataKey];
      })
    })

    // console.log(headers);
    // console.log(dataArray);

    // Every table cell is cleaned and counted (see util/pdfText.js).
    const pdf = createPdfTextTracker();
    doc.setFontSize(2);
    const title = "AssetPro Document Report";
    let content = {
      columns: headers,
      body: dataArray,
      didParseCell: pdf.cellHook()
    };

    doc.text(title, marginLeft, 40);
    doc.autoTable(content);
    const unprintable = pdf.count();
    if (unprintable > 0) {
      doc.setFontSize(10);
      doc.text(unprintableNote(unprintable), marginLeft, doc.lastAutoTable.finalY + 20);
    }
    doc.save(`report-${Date.now()}.pdf`)
    if (unprintable > 0) message.warning(unprintableToast(unprintable), 8);
  };

  downloadCSV = async (headers, data) => {
    // console.log(headers);
    const deepClonedData = _.cloneDeep(data);
    // let datesArray = [];
    let col = [];

    for (let i = 0; i < headers.length; i++) {
      let item = headers[i];
      if (item.key !== 'assetCode' && item.key !== 'assetType' && item.key !== 'subType' && item.key !== 'altName' && item.key !== 'locationName'
        && item.key !== 'subLocation') {
        // datesArray.push(item.key);
        deepClonedData.forEach(record => {
          record[item.key] = 'Not Attached';

          if (record.documents && record.documents.length) {
            let renewRecords = (record.documents || []).filter(d_item => d_item.type.name === item.key);
            if (renewRecords && renewRecords.length) {
              record[item.key] = 'Attached';
              renewRecords = renewRecords.filter(item => item.renewalDate);
              if (renewRecords && renewRecords.length) {
                renewRecords.sort((a, b) => new Date(b.renewalDate).getTime() - new Date(a.renewalDate).getTime());
                record[item.key] = (renewRecords && renewRecords.length) ? moment(renewRecords[0].renewalDate).format('DD-MM-YYYY') : 'Attached';
              }
            }
          }
        })
      }
      col.push(item.key);
    }

    // for (let i = 0; i < deepClonedData.length; i++) {
    //   let item = deepClonedData[i];
    // let keys = Object.keys(item);
    // for (let j = 0; j < keys.length; j++) {
    //   if (datesArray.includes(keys[j]) && item[keys[j]] !== 'Attached' && item[keys[j]] !== 'Not Attached' && item[keys[j]] !== 'Invalid Date') {
    //     // console.log(item['assetCode'], keys[j], item[keys[j]]);
    //     item[keys[j]] = moment(item[keys[j]]).format('DD-MM-YYYY');
    //   }
    // }
    // }
    // console.log(col);
    // console.log(deepClonedData);
    const csvString = [
      col,
      ...await Promise.all(deepClonedData.map(async itm =>
        await col.map(cl => [itm[cl] ? itm[cl] : 'Not Attached'])
      ))
    ]
      .map(e => e.join(","))
      .join("\n");
    var hiddenElement = document.createElement('a');
    hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csvString);
    hiddenElement.target = '_blank';
    hiddenElement.download = `Asset_Document_Report_${Date.now()}.csv`;
    hiddenElement.click();
  };


  onAttachClicked = (id) => {
    const url = this.props.getUrl(id);
    window.open(url);
  }

  render() {
    const {
      loading,
      title,
      resource,
      form,
      tableAssetData,
      equipmentSubTypes,
      // tableDocumentTypeData,
      assetCodes,
      documentFilters,
      filters,
      authUser,
    } = this.props;
    const documentTypes = filters && filters.type && filters.type.data && filters.type.data.data || [];
    const tableDocumentTypeData = [...documentTypes].filter(dt => this.state.selectedDocumentTypes.includes(dt._id));
    // console.log(tableAssetData);
    let assetDocumentData = _.cloneDeep(tableAssetData);
    const {
      clientFilterType,
      locationFilterType,
      assetTypeFilterType,
      assetSubTypeFilterType,
      assetCodeFilterType,
      documentTypeFilterType,
      downloadActive
    } = this.state;
    let locationFilterData = documentFilters && documentFilters.locations;
    const clientFilterData = documentFilters && documentFilters.clients;
    const assetTypes = documentFilters && documentFilters.assetType;
    // get form fields
    const {getFieldDecorator} = form;
    const locationType = form.getFieldValue('location');
    const clientType = form.getFieldValue('client');
    const assetType = form.getFieldValue('assetType');
    const assetSubType = form.getFieldValue('assetSubType');
    const assetCodeType = form.getFieldValue('assetCode');
    const documentType = form.getFieldValue('documentType');

    // Creating column
    const columns = [
      {
        title: 'Asset Code',
        dataIndex: 'assetCode',
        key: 'assetCode',
        sorter: (a, b) => a.assetCode.length - b.assetCode.length,
        sortDirections: ['descend', 'ascend'],
      },
      {
        title: 'Asset Type',
        dataIndex: 'assetType',
        key: 'assetType',
        sorter: (a, b) => a.assetType.length - b.assetType.length,
        sortDirections: ['descend', 'ascend'],
      },
      {
        title: 'Asset Sub Type',
        dataIndex: 'subType',
        key: 'subType',
        sorter: (a, b) => a.subType.length - b.subType.length,
        sortDirections: ['descend', 'ascend'],
      },
      {
        title: 'Alt Name',
        dataIndex: 'altName',
        key: 'altName',
        sorter: (a, b) => a.altName.length - b.altName.length,
        sortDirections: ['descend', 'ascend'],
      },
      {
        title: 'Location',
        dataIndex: 'locationName',
        key: 'locationName',
        sorter: (a, b) => a.locationName.length - b.locationName.length,
        sortDirections: ['descend', 'ascend'],
      },
      {
        title: 'Sub Location',
        dataIndex: 'subLocation',
        key: 'subLocation',
        sorter: (a, b) => a.subLocation.length - b.subLocation.length,
        sortDirections: ['descend', 'ascend'],
      }
    ];

    // Dynamic Columns
    downloadActive && tableDocumentTypeData && tableDocumentTypeData.length && tableDocumentTypeData.map(documentType => {
      columns.push({
        title: documentType.name,
        dataIndex: documentType.name,
        key: documentType.name,
        sorter: (a, b) => a[`${documentType.name}`] - b[`${documentType.name}`],
        sortDirections: ['descend', 'ascend'],
        render: (item, record) => {
          let color = 'white';
          // if(item && item !== 'Attached') {
          //   let Difference_In_Time = new Date(item).getTime() - new Date().getTime();
          //   if(Difference_In_Time < 0) {
          //     color = 'red';
          //   } else {
          //     let Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
          //     Difference_In_Days = parseInt(Difference_In_Days);
          //     if(record && record[`${documentType.name}pDays`] >= 0 && record[`${documentType.name}pDays`] >= Difference_In_Days) {
          //       color = 'yellow'
          //     }
          //     if(record && record[`${documentType.name}pDays`] >= 0 && record[`${documentType.name}pDays`] <= Difference_In_Days) {
          //       color = 'green'
          //     }
          //   }
          // }
          //
          let headItem = (!record.documents || !record.documents.length) ? 'Not Attached' : 'Attached';
          let renewRecords = [...record.documents];
          if (record.documents && record.documents.length) {
            renewRecords = (record.documents || []).filter(item => item.type._id === documentType._id);
            if (renewRecords && renewRecords.length) {
              headItem = 'Attached';
              renewRecords = renewRecords.filter(item => item.renewalDate);
              if (renewRecords && renewRecords.length) {
                renewRecords.sort((a, b) => new Date(b.renewalDate).getTime() - new Date(a.renewalDate).getTime());
                headItem = (renewRecords && renewRecords.length) ? renewRecords[0].renewalDate : headItem;
              }
            } else {
              headItem = 'Not Attached';
            }
          } else
            headItem = 'Not Attached';

          if (headItem !== 'Not Attached' && headItem !== 'Attached') {
            let Difference_In_Time = new Date(headItem).getTime() - new Date().getTime();
            if (Difference_In_Time < 0) {
              color = 'red';
            } else {
              let Difference_In_Days = parseInt(Difference_In_Time / (1000 * 3600 * 24));
              if (documentType && documentType.processingPeriodInDays && documentType.processingPeriodInDays >= Difference_In_Days)
                color = 'yellow';
              else
                color = 'green';
            }
          }

          assetDocumentData.forEach(doc => {
            if (doc._id === record._id) {
              doc[documentType.name] = headItem;
            }
          });


          //
          // </div>
          // <div key={record._id} style={{
          //   color: color === 'white' ? "black" : color === 'yellow' ? 'black' : 'white',
          //   // backgroundColor: color,
          //   fontWeight: "bold",
          //   cursor: 'pointer'
          // }}>
          return headItem === 'Not Attached' ? 'Not Attached' : <div key={record._id}>
            <Dropdown overlay={this.dropdownData.bind(this, [...record.documents], documentType.name, false)}
                      trigger={['click']}>
              <MyButton
                color={color}>{headItem === 'Attached' ? 'Attached' : moment(headItem).format('DD-MM-YYYY')}<Icon
                type="down"/></MyButton>
            </Dropdown>
          </div>
        }
      });
    });

    //Headers For Csv
    const headers = columns.map(item => {
      return {
        label: item.title,
        key: item.dataIndex,
      }
    });

    const cols = columns.map(item => {
      return {
        header: item.title,
        dataKey: item.dataIndex,
      }
    });

    return (
      <Spin spinning={loading}>
        <Card className={`gx-card-metrics`} title={`ASSET ${sanitizeFieldName(resource)} ${title}`}>
          <Form onSubmit={this.handleSubmit} className="ant-advanced-search-form" layout="inline" labelAlign="left">

            <Row gutter={8}>
              <Col xs={12} sm={6} md={4} lg={2.5} xl={2.5}>
                {/* Location */}
                <Form.Item key={'location'} label={'Select Location'} style={{width: '100%'}}>
                  {getFieldDecorator(`location`, {
                    rules: [{required: true, message: `Location is required!`}],
                    initialValue: [],
                  })(<Select
                    showSearch
                    mode="multiple"
                    onSelect={this.hideDownloadButton}
                    onChange={this.onLocationChange}
                    filterOption={(input, option) =>
                      (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                    }
                    placeholder={`Please Select Multiple Location`}
                  >
                    {authUser && authUser.locations && authUser.locations.length ? <Select.Option key={'AllLocation'}
                                                                                                  disabled={locationFilterType !== 'All' && locationType && locationType.length > 0}
                                                                                                  onClick={this.handleSelect.bind(this, 'location', 'All')}
                                                                                                  value={'All'}>All</Select.Option> : ''}
                    <Select.Option key={'intransit'}
                                   disabled={locationFilterType !== 'INTRANSIT' && locationType && locationType.length > 0}
                                   onClick={this.handleSelect.bind(this, 'location', 'INTRANSIT')}
                                   value={'INTRANSIT'}>Intransit</Select.Option>
                    {(authUser && authUser.locations || []).map(item =>
                      <Select.Option key={item._id}
                                     onClick={this.handleSelect.bind(this, 'location', '')}
                                     disabled={locationType && locationType.findIndex(item => item === 'All' || item === 'INTRANSIT') >= 0}
                                     value={item._id}>{item.name}</Select.Option>)}
                  </Select>)
                  }
                </Form.Item>
              </Col>

              <Col xs={12} sm={6} md={4} lg={2.5} xl={2.5}>
                {/* Client */}
                <Form.Item key={'client'} label={'Select Sub Location'} style={{width: '100%'}}>
                  {getFieldDecorator(`client`, {
                    rules: [{required: true, message: `Sub Location is required!`}],
                    initialValue: [],
                  })(<Select
                    showSearch
                    mode="multiple"
                    onSelect={this.hideDownloadButton}
                    onChange={this.onClientChange}
                    disabled={locationFilterType === 'INTRANSIT'}
                    filterOption={(input, option) =>
                      (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                    }
                    placeholder={`Please Select Sub Location`}
                  >
                    {authUser && authUser.clients && authUser.clients.length ? <Select.Option key={'AllClient'}
                                                                                              onClick={this.handleSelect.bind(this, 'client', 'All')}
                                                                                              disabled={clientFilterType !== 'All' && clientType && clientType.length > 0}
                                                                                              value={'All'}>All</Select.Option> : ''}
                    <Select.Option key={'OffClient'}
                                   onClick={this.handleSelect.bind(this, 'client', 'Off')}
                                   disabled={clientFilterType !== 'Off' && clientType && clientType.length > 0}
                                   value={'Off'}>Off</Select.Option>

                    {(authUser && authUser.clients || []).map(item =>
                      <Select.Option key={item._id}
                                     onClick={this.handleSelect.bind(this, 'client', '')}
                                     disabled={clientType && clientType.findIndex(item => (item === 'All' || item === 'Idle' || item === 'Off')) >= 0}
                                     value={item._id}>{item.name}</Select.Option>)}
                  </Select>)
                  }
                </Form.Item>
              </Col>

              <Col xs={12} sm={6} md={4} lg={2.5} xl={2.5}>
                {/* Asset Type */}
                <Form.Item key={'assetType'} label={'Select Asset Types'} style={{width: '100%'}}>
                  {getFieldDecorator(`assetType`, {
                    rules: [{required: true, message: `Asset types is required!`}],
                    initialValue: [],
                  })(<Select
                    showSearch
                    mode="multiple"
                    onSelect={this.assetTypeSelected}
                    onChange={this.handleAssetTypesChange}
                    filterOption={(input, option) =>
                      (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                    }
                    placeholder={`Please Select Multiple Asset Type`}
                  >
                    {assetTypes && assetTypes.length ? <Select.Option key={'AllAssetType'}
                                                                      onClick={this.handleSelect.bind(this, 'assetType', 'All')}
                                                                      disabled={assetTypeFilterType !== 'All' && assetType && assetType.length > 0}
                                                                      value={'All'}>All</Select.Option> : ''}
                    {(assetTypes || []).map(item =>
                      <Select.Option key={item._id}
                                     onClick={this.handleSelect.bind(this, 'assetType', '')}
                                     disabled={assetType && assetType.findIndex(item => item === 'All') >= 0}
                                     value={item._id}>{item.name}</Select.Option>)}
                  </Select>)
                  }
                </Form.Item>
              </Col>

              <Col xs={12} sm={6} md={4} lg={2.5} xl={2.5} style={{display: 'block'}}>
                {/* Asset Sub Type */}
                <Form.Item key={'Asset Sub Type'} label={'Select Asset Sub Type'} style={{width: '100%'}}>
                  {getFieldDecorator(`assetSubType`, {
                    rules: [{required: true, message: `Asset Sub Type is required!`}],
                    initialValue: [],
                  })(<Select
                    showSearch
                    mode="multiple"
                    onSelect={this.assetSubTypeSelected}
                    disabled={this.state.assetSubTypeActive}
                    onChange={this.onSubTypeChange}
                    filterOption={(input, option) =>
                      (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                    }
                    placeholder={`Please Select Multiple Asset Sub Type`}
                  >
                    {equipmentSubTypes && equipmentSubTypes.length ? <Select.Option key={'AllAssetSubType'}
                                                                                    onClick={this.handleSelect.bind(this, 'assetSubType', 'All')}
                                                                                    disabled={assetSubTypeFilterType !== 'All' && assetSubType && assetSubType.length > 0}
                                                                                    value={'All'}>All</Select.Option> : ''}
                    {(equipmentSubTypes || []).map(item =>
                      <Select.Option key={item._id}
                                     onClick={this.handleSelect.bind(this, 'assetSubType', '')}
                                     disabled={assetSubType && assetSubType.findIndex(item => (item === 'All' || item === 'Off')) >= 0}
                                     value={item._id}>{item.name}</Select.Option>)}
                  </Select>)
                  }
                </Form.Item>
              </Col>

              <Col xs={12} sm={6} md={4} lg={2.5} xl={2.5} style={{display: 'block'}}>
                {/* Asset Code */}
                <Form.Item key={'Asset Code'} label={'Search Asset Code'} style={{width: '100%'}}>
                  {getFieldDecorator(`assetCode`, {
                    rules: [{required: true, message: `Asset Code is required!`}],
                    initialValue: [],
                  })(<Select
                    showSearch
                    mode="multiple"
                    defaultActiveFirstOption={false}
                    showArrow={false}
                    notFoundContent={null}
                    filterOption={false}
                    onSelect={this.assetCodeSelected}
                    onSearch={this.fetchDocumentType}
                    disabled={this.state.assetCodeActive}
                    placeholder={`Please Select Multiple Asset Code`}
                  >
                    <Select.Option key={'AllAssetCode'}
                                   onClick={this.handleSelect.bind(this, 'assetCode', 'All')}
                                   disabled={assetCodeFilterType !== 'All' && assetCodeType && assetCodeType.length > 0}
                                   value={'All'}>All</Select.Option>
                    {(assetCodes || []).map(item =>
                      <Select.Option key={item._id}
                                     onClick={this.handleSelect.bind(this, 'assetCode', '')}
                                     disabled={assetCodeType && assetCodeType.length && assetCodeType.findIndex(item => (item === 'All' || item === 'Off')) >= 0}
                                     value={item._id}>{item.assetCode}</Select.Option>)}
                  </Select>)
                  }
                </Form.Item>
              </Col>

              <Col xs={12} sm={6} md={4} lg={2.5} xl={2.5} style={{display: 'block'}}>
                {/* Document Type */}
                <Form.Item key={'Document Type'} label={'Select Document Type'} style={{width: '100%'}}>
                  {getFieldDecorator(`documentType`, {
                    rules: [{required: true, message: `Document Type is required!`}],
                    initialValue: [],
                  })(<Select
                    showSearch
                    mode="multiple"
                    disabled={this.state.documentTypeActive}
                    onSelect={this.hideDownloadButton}
                    filterOption={(input, option) =>
                      (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                    }
                    placeholder={`Please Select Multiple Document Type`}
                  >
                    {<Select.Option key={'AllDocumentType'}
                                    onClick={this.handleSelect.bind(this, 'documentType', 'All')}
                                    disabled={documentTypeFilterType !== 'All' && documentType && documentType.length > 0}
                                    value={'All'}>All</Select.Option>}
                    {(documentTypes || []).map(item =>
                      <Select.Option key={item._id}
                                     onClick={this.handleSelect.bind(this, 'documentType', '')}
                                     disabled={documentType && documentType.findIndex(item => (item === 'All' || item === 'Off')) >= 0}
                                     value={item._id}>{item.name}</Select.Option>)}
                  </Select>)
                  }
                </Form.Item>
              </Col>
            </Row>

            <Form.Item>
              <Button type="primary" className="gx-mb-0" htmlType="submit" loading={loading}>
                Generate Report
              </Button>
            </Form.Item>
            {
              downloadActive ? <Form.Item>
                <Button type="primary" className="gx-mb-0"
                        onClick={this.downloadCSV.bind(this, headers, tableAssetData)}>Download CSV</Button>
                {/*<CSVLink filename={'report.csv'} className='gx-mb-0 download-button' data={tableAssetData || []}*/}
                {/*         headers={headers}>*/}
                {/*  Download CSV*/}
                {/*</CSVLink>*/}
              </Form.Item> : ''
            }
            {
              downloadActive ? <Form.Item>
                <Button type="primary" className="gx-mb-0"
                        onClick={this.downloadPdf.bind(this, cols, tableAssetData)}>Download Pdf</Button>
              </Form.Item> : ''
            }
          </Form>
          <Table bordered columns={columns} dataSource={downloadActive ? tableAssetData : []}
                 scroll={{x: true}}/>
        </Card>
      </Spin>
    )
  }


}

const
  CreateForm = Form.create({
    name: 'global_state',
    onFieldsChange(props, changedFields) {
      props.onChange(changedFields);
    },
  })(Report);

export default CreateForm;

